import { render, staticRenderFns } from "./teachersAndStudentsIntroduce.vue?vue&type=template&id=0756885a&scoped=true"
import script from "./teachersAndStudentsIntroduce.vue?vue&type=script&lang=js"
export * from "./teachersAndStudentsIntroduce.vue?vue&type=script&lang=js"
import style0 from "./teachersAndStudentsIntroduce.vue?vue&type=style&index=0&id=0756885a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0756885a",
  null
  
)

export default component.exports